import { isPseudoLocale } from 'libs.i18n-core';
/*
  Pseudo-locales (`en-XA`, `ar-XB`) are a localization-testing aid selected in the profile editor.
  Unlike real locales they are deliberately never persisted to the identity, so without a client-side
  store the choice would be lost on refresh. We persist the active pseudo-locale in localStorage and
  give it precedence over the identity/browser locale at startup.

  Only valid pseudo-locale values are ever honored or written; anything else clears the key. This
  keeps a non-pseudo (real) selection from lingering here — real locales persist to the identity.
*/
const STORAGE_KEY = 'medable.ui.pseudoLocale';
const getStorage = () => {
    try {
        return window.localStorage;
    }
    catch (_a) {
        // localStorage can throw when access is blocked (private mode, sandboxed iframe, SSR).
        return undefined;
    }
};
/** Returns the persisted pseudo-locale, or `undefined` when none is set (clearing any stale value). */
export const getStoredPseudoLocale = () => {
    const storage = getStorage();
    const stored = storage === null || storage === void 0 ? void 0 : storage.getItem(STORAGE_KEY);
    if (stored && isPseudoLocale(stored)) {
        return stored;
    }
    if (stored) {
        storage === null || storage === void 0 ? void 0 : storage.removeItem(STORAGE_KEY);
    }
    return undefined;
};
/** Persists a pseudo-locale selection; any non-pseudo value clears the stored override. */
export const setStoredPseudoLocale = (locale) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    if (locale && isPseudoLocale(locale)) {
        storage.setItem(STORAGE_KEY, locale);
    }
    else {
        storage.removeItem(STORAGE_KEY);
    }
};
